import { getYoutubeVideoId } from '../components/videovizitky/video-card-data';

export type TourVideo = { id: string; name: string };

/** Published Objavuj svet field IDs. Further numbered Video fields need no FE limit. */
const VIDEO_FIELD_IDS = new Set([4, 5, 6, 7, 8]);

/** Keep video slots in the Videos tab, without swallowing rich-text fields or groups. */
export function isTourVideoField(field: unknown): boolean {
  if (!field || typeof field !== 'object') return false;
  const candidate = field as { id?: unknown; name?: unknown; type?: unknown };
  const name = typeof candidate.name === 'string' ? candidate.name.trim() : '';
  return (
    (!candidate.type || candidate.type === 'text' || candidate.type === 'textbox') &&
    ((typeof candidate.id === 'number' && VIDEO_FIELD_IDS.has(candidate.id)) ||
      /^video\s+\d+$/i.test(name))
  );
}

export function getTourVideos(tour: {
  content_fields?: unknown;
  text_fields?: unknown;
}): TourVideo[] {
  // An explicitly empty new collection must not resurrect removed legacy videos.
  const fields = Object.prototype.hasOwnProperty.call(tour, 'content_fields')
    ? tour.content_fields
    : tour.text_fields;
  if (!Array.isArray(fields)) return [];
  const seen = new Set<string>();
  return fields.flatMap(field => {
    if (!isTourVideoField(field)) return [];
    const name = typeof field.name === 'string' ? field.name.trim() : '';
    const id = getYoutubeVideoId(field.value);
    if (!id || seen.has(id)) return [];
    seen.add(id);
    return [{ id, name: name || `Video ${seen.size}` }];
  });
}
